module.exports = "query CustomerOverviewReturnsInfosQuery{productReturnDownloadRoute:route(name:\"return_download\",arguments:\"return_file_id=None\"){url}}"